import { useMemo } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';

import {
  StyledFormGroup,
  StyledInput,
  StyledLink,
  StyledSelectMenu,
  StyledText,
} from '@selfserve/react-ui';

import { AddOnItem, PlanItemInfo } from '../data';
import { FormValues } from '../feature/plans-overview';
import { links } from '@selfserve/react-utils';

const StyledPlanModalSubtitle = styled(StyledText)(
  ({ theme }: { theme?: any }) => ({
    marginBottom: theme.spacing(4),
  })
);

const StyledHelpText = styled(StyledText)(({ theme }: { theme?: any }) => ({
  marginBottom: theme.spacing(5),
  textAlign: 'center',
}));

const Link = StyledLink.withComponent('a');

interface Props {
  selectedItem?: PlanItemInfo | AddOnItem;
  formik: FormikProps<FormValues>;
}

export const UnsubscribeFields = ({
  selectedItem,
  formik: { setFieldValue, handleChange, handleBlur, values },
}: Props) => {
  const { t } = useTranslation();
  const reasons = useMemo(
    () => [
      { text: t('reasons.issues'), value: t('reasons.issues') },
      { text: t('reasons.features'), value: t('reasons.features') },
      { text: t('reasons.price'), value: t('reasons.price') },
      { text: t('reasons.other'), value: t('reasons.other') },
    ],
    [t]
  );
  return (
    <>
      <StyledPlanModalSubtitle>
        {`${t('common.end-subscription')} `}
        <StyledText as="span" bold>
          {(selectedItem as PlanItemInfo)?.plan?.displayName ||
            (selectedItem as AddOnItem)?.displayName}
        </StyledText>
      </StyledPlanModalSubtitle>
      <StyledFormGroup>
        <StyledSelectMenu
          fullWidth
          options={reasons}
          name="reason"
          inputLabel={t('common.select-reason')}
          placeholder="Select a reason"
          value={values.reason}
          onChange={(value) => setFieldValue('reason', value)}
          onBlur={handleBlur}
        />
      </StyledFormGroup>
      <StyledFormGroup largeMargin>
        <StyledInput
          multiline
          rows={3}
          name="extendedInfo"
          inputLabel={t('common.more-info')}
          value={values.extendedInfo}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </StyledFormGroup>
      <StyledHelpText as="div" className="help-mail'">
        {`${t('common.need-help')} `}
        <Link to="" href={`mailto:${links.HELP_EMAIL}`}>
          {links.HELP_EMAIL}
        </Link>
      </StyledHelpText>
    </>
  );
};
